import React from "react";
import { Compass, Lock, Award, LayoutGrid, BrainCircuit, HeartHandshake, FileCheck2 } from "lucide-react";

const items = [
  { icon: Compass, t: "Atendimento estratégico", d: "Consultoria sob medida para cada operação." },
  { icon: Lock, t: "Operações seguras", d: "Respaldo jurídico e validação documental rigorosa." },
  { icon: Award, t: "Credibilidade", d: "Reputação construída sobre tradição e ética." },
  { icon: LayoutGrid, t: "Estrutura profissional", d: "Time multidisciplinar e processos auditáveis." },
  { icon: BrainCircuit, t: "Expertise financeira", d: "Conhecimento profundo do mercado de consórcio." },
  { icon: HeartHandshake, t: "Atendimento humanizado", d: "Relacionamento próximo, sem scripts engessados." },
  { icon: FileCheck2, t: "Transparência total", d: "Cada etapa documentada e comunicada de forma clara." },
  { icon: Award, t: "Operando desde 2010", d: "Mais de uma década estruturando operações de alto padrão." },
];

export default function Differentials() {
  return (
    <section
      id="diferenciais"
      data-testid="differentials-section"
      className="relative py-24 md:py-36 overflow-hidden"
    >
      <div className="absolute inset-0">
        <div
          className="absolute inset-0"
          style={{
            background:
              "radial-gradient(ellipse at top right, rgba(212,175,55,0.12), transparent 60%), radial-gradient(ellipse at bottom left, rgba(20,30,60,0.4), transparent 70%), #05070D",
          }}
        />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-32">
            <div className="flex items-center gap-4 mb-6">
              <div className="gold-line" />
              <span className="overline">Diferenciais</span>
            </div>
            <h2 className="font-serif-ag text-white text-4xl md:text-5xl lg:text-[3.5rem] font-light leading-[1.04] tracking-[-0.015em]">
              O padrão{" "}
              <span className="text-[#D4AF37] italic">premium</span> que define o
              nosso trabalho.
            </h2>
            <p className="mt-8 text-[#A3ABB8] text-base md:text-lg font-light leading-relaxed max-w-md">
              Cada decisão é guiada por excelência operacional, integridade e
              compromisso com o resultado dos nossos clientes.
            </p>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-px bg-[#D4AF37]/10">
            {items.map((it, i) => (
              <div
                key={i}
                data-testid={`differential-${i}`}
                className="bg-[#05070D] p-7 md:p-9 hover:bg-[#0B101A] transition-colors duration-500"
              >
                <it.icon size={22} strokeWidth={1.2} className="text-[#D4AF37]" />
                <h3 className="mt-6 font-serif-ag text-white text-xl md:text-2xl font-medium leading-tight">
                  {it.t}
                </h3>
                <p className="mt-2 text-[#A3ABB8] text-sm font-light leading-relaxed">
                  {it.d}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
